export default "__VITE_ASSET__CNFj8pnq__"